import { AggregatedDeviceProtectionHistory, AssociatedDevice, Device, DevicesSummary } from 'mcsclient/models';
import { ApiCallResultStatus } from 'store/apiCallResultStatus';

export interface IDeviceDataState {
  deviceRemoveStatus: ApiCallResultStatus;
  deviceRemoveLoadError: string | undefined;
  devicesSummary: DevicesSummary;
  devicesSummaryLoadStatus: ApiCallResultStatus;
  devicesSummaryLoadError: string | undefined;
  device: { [deviceId: string]: Device };
  deviceLoadStatus: { [deviceId: string]: ApiCallResultStatus };
  deviceLastLoadError: string | undefined;
  deviceProtectionHistory: { [deviceId: string]: AggregatedDeviceProtectionHistory };
  deviceProtectionHistoryLoadStatus: { [deviceId: string]: ApiCallResultStatus };
  deviceProtectionHistoryLastLoadError: string | undefined;
  associatedDevices: AssociatedDevice[];
  associatedDevicesLoadStatus: ApiCallResultStatus;
  associatedDevicesLoadError: string | undefined;
}

export function getDefaultDevicesState(): IDeviceDataState {
  return {
    deviceRemoveStatus: ApiCallResultStatus.DEFAULT,
    deviceRemoveLoadError: undefined,
    devicesSummary: {},
    devicesSummaryLoadStatus: ApiCallResultStatus.DEFAULT,
    devicesSummaryLoadError: undefined,
    device: {},
    deviceLoadStatus: {},
    deviceLastLoadError: undefined,
    deviceProtectionHistory: {},
    deviceProtectionHistoryLoadStatus: {},
    deviceProtectionHistoryLastLoadError: undefined,
    associatedDevices: [],
    associatedDevicesLoadStatus: ApiCallResultStatus.DEFAULT,
    associatedDevicesLoadError: undefined,
  };
}
